import { Image } from "antd";
import React from "react";

const ImagePreview = ({ previewOpen, previewImage, setPreviewOpen }) => {
  return (
    previewImage && (
      <Image
        wrapperStyle={{
          display: "none",
        }}
        preview={{
          visible: previewOpen,
          onVisibleChange: (visible) => setPreviewOpen(visible),
          afterOpenChange: (visible) => !visible && setPreviewOpen(false),
        }}
        src={previewImage}
      />
    )
  );
};

export default ImagePreview;
